import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
import { config } from '@/lib/config';
import { getErrorCodeFromMessage, getErrorDisplay } from '@/lib/errorMessages';
import { useMessage, useNavigate } from '@/lib/hooks';
import { log } from '@/lib/log';
import { validateMessageOrigin } from '@/lib/util';

type MessageHandlerProps = {
  children?: React.ReactNode;
};

const MessageHandler = ({ children }: MessageHandlerProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [, dispatch] = useContext(Context);

  useMessage((e: MessageEvent) => {
    log(`MessageHandler: Receiving message from ${e.origin}`, e.data);

    validateMessageOrigin(e.origin, true);

    if (!e.data?.error) return;

    const { error: errorMessage } = e.data;
    const errorCode = getErrorCodeFromMessage(errorMessage);

    if (errorCode) {
      const display = getErrorDisplay(errorCode);
      const isPaymentPage = location.pathname === config.routes.payment;

      if (isPaymentPage && !display.redirect) {
        dispatch({
          type: ActionTypes.showError,
          payload: { title: display.title, message: display.message }
        });
        return;
      }

      navigate(config.routes.error, { searchParams: { code: errorCode } });
      return;
    }

    navigate(config.routes.error);
  });

  return children || null;
};

export { MessageHandler };
